import React from "react";

import PyqCpsExamComponent from "../pyqCpsExamComponent/PyqCpsExamContentComponent/PyqCpsExamContentComponent";
import PersistentSidebarLayout from "../../../../components/PersistentSidebarLayout/PersistentSidebarLayout";
import LoaderPopUp from "../../../../components/loader/loader";
import { connect } from "react-redux";
import Footer_component from "../../structure_components/desktop_screens/footer_component/Footer_component";

const PyqCpsExam = (props) => {
  let { history, loader, userData, userPreference, location } = props;
  return (
    <PersistentSidebarLayout>
      <div className="pyqCpsExamWrapper" style={{ overflowX: "hidden" }}>
        <div className="pyqCpsExamInrWrapper">
          <PyqCpsExamComponent
            history={history}
            userData={userData}
            userPreference={userPreference}
            location={location}
          />
        </div>
      </div>

      <Footer_component />
      {loader && <LoaderPopUp />}
    </PersistentSidebarLayout>
  );
};
const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};
export default connect(mapStateToProps)(PyqCpsExam);
